/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import {
  PhotoFormat_Enum,
  photoFormat_EnumFromJSON,
  photoFormat_EnumToJSON,
} from "../../../../gen/user_camera/photo_format";
import { CameraSettings, PhotoSettings, PhotoType } from "../../mission_camera_settings";

export const protobufPackage = "skills";

/** Extra metadata fields included in TakePhotoActionArgs */
export interface ExtraPhotoMetadata {
  /**
   * TODO(Quentin, Jeremy, Sam): Remove from spec. This field is ignored on new vehicle software
   * but we need it to continue to be defined for older vehicle versions.
   * Human readable name for the intended capture point. This does not name the file.
   */
  capturePointName: string;
  /** Deprecated in favor of "asset_*" fields */
  structureName: string;
  /** Deprecated in favor of "asset_*" fields */
  structureId: string;
  /**
   * Optional, string specifying asset UUID (refers to `uuid` of the `InspectionAssetInstance`
   * database model).
   */
  assetId: string;
  /**
   * Optional, string specifying asset customer ID (refers to the `customer_asset_id` of the
   * `InspectionAssetInstance`database model).
   */
  assetCustomerId: string;
  /** Optional field associating multiple photos taken at a capture point together. */
  capturePointId: string;
}

/** Arguments for taking a photo. */
export interface TakePhotoActionArgs {
  /** DEPRECATED use photo_settings field */
  photoType:
    | PhotoType
    | undefined;
  /** Extra metadata to be injected into photo exif */
  extraMetadata:
    | ExtraPhotoMetadata
    | undefined;
  /** General camera settings like exposure time, iso, etc. */
  cameraSettings:
    | CameraSettings
    | undefined;
  /** Photo specific settings */
  photoSettings:
    | PhotoSettings
    | undefined;
  /**
   * Wait for autofocus state to be `PASSIVE_FOCUSED` or `FOCUSED_LOCKED` before taking the photo.
   * A timeout applies, and this will have no effect on incompatible vehicles or TakePhoto actions
   * that do not request an EO photo. If waiting for autofocus is not applicable (e.g., the focus
   * mode is `OFF`), the timeout will not apply.
   */
  waitForFocusToConverge: boolean;
}

export interface Photo {
  utime: number;
  requestUtime: number;
  path: string;
  mediaId: string;
  photoFormat: PhotoFormat_Enum;
}

export interface TakePhotoResultData {
  eoResult: TakePhotoResultData_PhotoResult;
  irResult: TakePhotoResultData_PhotoResult;
  eoPhotos: Photo[];
  irPhotos: Photo[];
  eoFocusConvergenceTimedOut?: boolean | undefined;
}

export enum TakePhotoResultData_PhotoResult {
  UNKNOWN = 0,
  SUCCESS = 1,
  SKIPPED = 2,
  FAILURE = 3,
  UNRECOGNIZED = -1,
}

export function takePhotoResultData_PhotoResultFromJSON(object: any): TakePhotoResultData_PhotoResult {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return TakePhotoResultData_PhotoResult.UNKNOWN;
    case 1:
    case "SUCCESS":
      return TakePhotoResultData_PhotoResult.SUCCESS;
    case 2:
    case "SKIPPED":
      return TakePhotoResultData_PhotoResult.SKIPPED;
    case 3:
    case "FAILURE":
      return TakePhotoResultData_PhotoResult.FAILURE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TakePhotoResultData_PhotoResult.UNRECOGNIZED;
  }
}

export function takePhotoResultData_PhotoResultToJSON(object: TakePhotoResultData_PhotoResult): string {
  switch (object) {
    case TakePhotoResultData_PhotoResult.UNKNOWN:
      return "UNKNOWN";
    case TakePhotoResultData_PhotoResult.SUCCESS:
      return "SUCCESS";
    case TakePhotoResultData_PhotoResult.SKIPPED:
      return "SKIPPED";
    case TakePhotoResultData_PhotoResult.FAILURE:
      return "FAILURE";
    case TakePhotoResultData_PhotoResult.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface TakePhotoActionStateData {
  eoRequestUtime: number;
  irRequestUtime: number;
}

function createBaseExtraPhotoMetadata(): ExtraPhotoMetadata {
  return {
    capturePointName: "",
    structureName: "",
    structureId: "",
    assetId: "",
    assetCustomerId: "",
    capturePointId: "",
  };
}

export const ExtraPhotoMetadata = {
  encode(message: ExtraPhotoMetadata, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.capturePointName !== "") {
      writer.uint32(10).string(message.capturePointName);
    }
    if (message.structureName !== "") {
      writer.uint32(18).string(message.structureName);
    }
    if (message.structureId !== "") {
      writer.uint32(26).string(message.structureId);
    }
    if (message.assetId !== "") {
      writer.uint32(42).string(message.assetId);
    }
    if (message.assetCustomerId !== "") {
      writer.uint32(50).string(message.assetCustomerId);
    }
    if (message.capturePointId !== "") {
      writer.uint32(34).string(message.capturePointId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ExtraPhotoMetadata {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExtraPhotoMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.capturePointName = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.structureName = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.structureId = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.assetId = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.assetCustomerId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.capturePointId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExtraPhotoMetadata {
    return {
      capturePointName: isSet(object.capturePointName) ? globalThis.String(object.capturePointName) : "",
      structureName: isSet(object.structureName) ? globalThis.String(object.structureName) : "",
      structureId: isSet(object.structureId) ? globalThis.String(object.structureId) : "",
      assetId: isSet(object.assetId) ? globalThis.String(object.assetId) : "",
      assetCustomerId: isSet(object.assetCustomerId) ? globalThis.String(object.assetCustomerId) : "",
      capturePointId: isSet(object.capturePointId) ? globalThis.String(object.capturePointId) : "",
    };
  },

  toJSON(message: ExtraPhotoMetadata): unknown {
    const obj: any = {};
    if (message.capturePointName !== "") {
      obj.capturePointName = message.capturePointName;
    }
    if (message.structureName !== "") {
      obj.structureName = message.structureName;
    }
    if (message.structureId !== "") {
      obj.structureId = message.structureId;
    }
    if (message.assetId !== "") {
      obj.assetId = message.assetId;
    }
    if (message.assetCustomerId !== "") {
      obj.assetCustomerId = message.assetCustomerId;
    }
    if (message.capturePointId !== "") {
      obj.capturePointId = message.capturePointId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExtraPhotoMetadata>, I>>(base?: I): ExtraPhotoMetadata {
    return ExtraPhotoMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExtraPhotoMetadata>, I>>(object: I): ExtraPhotoMetadata {
    const message = createBaseExtraPhotoMetadata();
    message.capturePointName = object.capturePointName ?? "";
    message.structureName = object.structureName ?? "";
    message.structureId = object.structureId ?? "";
    message.assetId = object.assetId ?? "";
    message.assetCustomerId = object.assetCustomerId ?? "";
    message.capturePointId = object.capturePointId ?? "";
    return message;
  },
};

function createBaseTakePhotoActionArgs(): TakePhotoActionArgs {
  return {
    photoType: undefined,
    extraMetadata: undefined,
    cameraSettings: undefined,
    photoSettings: undefined,
    waitForFocusToConverge: false,
  };
}

export const TakePhotoActionArgs = {
  encode(message: TakePhotoActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.photoType !== undefined) {
      PhotoType.encode(message.photoType, writer.uint32(10).fork()).ldelim();
    }
    if (message.extraMetadata !== undefined) {
      ExtraPhotoMetadata.encode(message.extraMetadata, writer.uint32(18).fork()).ldelim();
    }
    if (message.cameraSettings !== undefined) {
      CameraSettings.encode(message.cameraSettings, writer.uint32(26).fork()).ldelim();
    }
    if (message.photoSettings !== undefined) {
      PhotoSettings.encode(message.photoSettings, writer.uint32(34).fork()).ldelim();
    }
    if (message.waitForFocusToConverge === true) {
      writer.uint32(40).bool(message.waitForFocusToConverge);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TakePhotoActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTakePhotoActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.photoType = PhotoType.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.extraMetadata = ExtraPhotoMetadata.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.cameraSettings = CameraSettings.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.photoSettings = PhotoSettings.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.waitForFocusToConverge = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TakePhotoActionArgs {
    return {
      photoType: isSet(object.photoType) ? PhotoType.fromJSON(object.photoType) : undefined,
      extraMetadata: isSet(object.extraMetadata) ? ExtraPhotoMetadata.fromJSON(object.extraMetadata) : undefined,
      cameraSettings: isSet(object.cameraSettings) ? CameraSettings.fromJSON(object.cameraSettings) : undefined,
      photoSettings: isSet(object.photoSettings) ? PhotoSettings.fromJSON(object.photoSettings) : undefined,
      waitForFocusToConverge: isSet(object.waitForFocusToConverge)
        ? globalThis.Boolean(object.waitForFocusToConverge)
        : false,
    };
  },

  toJSON(message: TakePhotoActionArgs): unknown {
    const obj: any = {};
    if (message.photoType !== undefined) {
      obj.photoType = PhotoType.toJSON(message.photoType);
    }
    if (message.extraMetadata !== undefined) {
      obj.extraMetadata = ExtraPhotoMetadata.toJSON(message.extraMetadata);
    }
    if (message.cameraSettings !== undefined) {
      obj.cameraSettings = CameraSettings.toJSON(message.cameraSettings);
    }
    if (message.photoSettings !== undefined) {
      obj.photoSettings = PhotoSettings.toJSON(message.photoSettings);
    }
    if (message.waitForFocusToConverge === true) {
      obj.waitForFocusToConverge = message.waitForFocusToConverge;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TakePhotoActionArgs>, I>>(base?: I): TakePhotoActionArgs {
    return TakePhotoActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TakePhotoActionArgs>, I>>(object: I): TakePhotoActionArgs {
    const message = createBaseTakePhotoActionArgs();
    message.photoType = (object.photoType !== undefined && object.photoType !== null)
      ? PhotoType.fromPartial(object.photoType)
      : undefined;
    message.extraMetadata = (object.extraMetadata !== undefined && object.extraMetadata !== null)
      ? ExtraPhotoMetadata.fromPartial(object.extraMetadata)
      : undefined;
    message.cameraSettings = (object.cameraSettings !== undefined && object.cameraSettings !== null)
      ? CameraSettings.fromPartial(object.cameraSettings)
      : undefined;
    message.photoSettings = (object.photoSettings !== undefined && object.photoSettings !== null)
      ? PhotoSettings.fromPartial(object.photoSettings)
      : undefined;
    message.waitForFocusToConverge = object.waitForFocusToConverge ?? false;
    return message;
  },
};

function createBasePhoto(): Photo {
  return { utime: 0, requestUtime: 0, path: "", mediaId: "", photoFormat: 0 };
}

export const Photo = {
  encode(message: Photo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.requestUtime !== 0) {
      writer.uint32(16).int64(message.requestUtime);
    }
    if (message.path !== "") {
      writer.uint32(26).string(message.path);
    }
    if (message.mediaId !== "") {
      writer.uint32(34).string(message.mediaId);
    }
    if (message.photoFormat !== 0) {
      writer.uint32(40).int32(message.photoFormat);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Photo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePhoto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.requestUtime = longToNumber(reader.int64() as Long);
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.path = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.mediaId = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.photoFormat = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Photo {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      requestUtime: isSet(object.requestUtime) ? globalThis.Number(object.requestUtime) : 0,
      path: isSet(object.path) ? globalThis.String(object.path) : "",
      mediaId: isSet(object.mediaId) ? globalThis.String(object.mediaId) : "",
      photoFormat: isSet(object.photoFormat) ? photoFormat_EnumFromJSON(object.photoFormat) : 0,
    };
  },

  toJSON(message: Photo): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.requestUtime !== 0) {
      obj.requestUtime = Math.round(message.requestUtime);
    }
    if (message.path !== "") {
      obj.path = message.path;
    }
    if (message.mediaId !== "") {
      obj.mediaId = message.mediaId;
    }
    if (message.photoFormat !== 0) {
      obj.photoFormat = photoFormat_EnumToJSON(message.photoFormat);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Photo>, I>>(base?: I): Photo {
    return Photo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Photo>, I>>(object: I): Photo {
    const message = createBasePhoto();
    message.utime = object.utime ?? 0;
    message.requestUtime = object.requestUtime ?? 0;
    message.path = object.path ?? "";
    message.mediaId = object.mediaId ?? "";
    message.photoFormat = object.photoFormat ?? 0;
    return message;
  },
};

function createBaseTakePhotoResultData(): TakePhotoResultData {
  return { eoResult: 0, irResult: 0, eoPhotos: [], irPhotos: [], eoFocusConvergenceTimedOut: undefined };
}

export const TakePhotoResultData = {
  encode(message: TakePhotoResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.eoResult !== 0) {
      writer.uint32(8).int32(message.eoResult);
    }
    if (message.irResult !== 0) {
      writer.uint32(16).int32(message.irResult);
    }
    for (const v of message.eoPhotos) {
      Photo.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    for (const v of message.irPhotos) {
      Photo.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    if (message.eoFocusConvergenceTimedOut !== undefined) {
      writer.uint32(40).bool(message.eoFocusConvergenceTimedOut);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TakePhotoResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTakePhotoResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.eoResult = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.irResult = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.eoPhotos.push(Photo.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.irPhotos.push(Photo.decode(reader, reader.uint32()));
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.eoFocusConvergenceTimedOut = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TakePhotoResultData {
    return {
      eoResult: isSet(object.eoResult) ? takePhotoResultData_PhotoResultFromJSON(object.eoResult) : 0,
      irResult: isSet(object.irResult) ? takePhotoResultData_PhotoResultFromJSON(object.irResult) : 0,
      eoPhotos: globalThis.Array.isArray(object?.eoPhotos) ? object.eoPhotos.map((e: any) => Photo.fromJSON(e)) : [],
      irPhotos: globalThis.Array.isArray(object?.irPhotos) ? object.irPhotos.map((e: any) => Photo.fromJSON(e)) : [],
      eoFocusConvergenceTimedOut: isSet(object.eoFocusConvergenceTimedOut)
        ? globalThis.Boolean(object.eoFocusConvergenceTimedOut)
        : undefined,
    };
  },

  toJSON(message: TakePhotoResultData): unknown {
    const obj: any = {};
    if (message.eoResult !== 0) {
      obj.eoResult = takePhotoResultData_PhotoResultToJSON(message.eoResult);
    }
    if (message.irResult !== 0) {
      obj.irResult = takePhotoResultData_PhotoResultToJSON(message.irResult);
    }
    if (message.eoPhotos?.length) {
      obj.eoPhotos = message.eoPhotos.map((e) => Photo.toJSON(e));
    }
    if (message.irPhotos?.length) {
      obj.irPhotos = message.irPhotos.map((e) => Photo.toJSON(e));
    }
    if (message.eoFocusConvergenceTimedOut !== undefined) {
      obj.eoFocusConvergenceTimedOut = message.eoFocusConvergenceTimedOut;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TakePhotoResultData>, I>>(base?: I): TakePhotoResultData {
    return TakePhotoResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TakePhotoResultData>, I>>(object: I): TakePhotoResultData {
    const message = createBaseTakePhotoResultData();
    message.eoResult = object.eoResult ?? 0;
    message.irResult = object.irResult ?? 0;
    message.eoPhotos = object.eoPhotos?.map((e) => Photo.fromPartial(e)) || [];
    message.irPhotos = object.irPhotos?.map((e) => Photo.fromPartial(e)) || [];
    message.eoFocusConvergenceTimedOut = object.eoFocusConvergenceTimedOut ?? undefined;
    return message;
  },
};

function createBaseTakePhotoActionStateData(): TakePhotoActionStateData {
  return { eoRequestUtime: 0, irRequestUtime: 0 };
}

export const TakePhotoActionStateData = {
  encode(message: TakePhotoActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.eoRequestUtime !== 0) {
      writer.uint32(8).int64(message.eoRequestUtime);
    }
    if (message.irRequestUtime !== 0) {
      writer.uint32(16).int64(message.irRequestUtime);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TakePhotoActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTakePhotoActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.eoRequestUtime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.irRequestUtime = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TakePhotoActionStateData {
    return {
      eoRequestUtime: isSet(object.eoRequestUtime) ? globalThis.Number(object.eoRequestUtime) : 0,
      irRequestUtime: isSet(object.irRequestUtime) ? globalThis.Number(object.irRequestUtime) : 0,
    };
  },

  toJSON(message: TakePhotoActionStateData): unknown {
    const obj: any = {};
    if (message.eoRequestUtime !== 0) {
      obj.eoRequestUtime = Math.round(message.eoRequestUtime);
    }
    if (message.irRequestUtime !== 0) {
      obj.irRequestUtime = Math.round(message.irRequestUtime);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TakePhotoActionStateData>, I>>(base?: I): TakePhotoActionStateData {
    return TakePhotoActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TakePhotoActionStateData>, I>>(object: I): TakePhotoActionStateData {
    const message = createBaseTakePhotoActionStateData();
    message.eoRequestUtime = object.eoRequestUtime ?? 0;
    message.irRequestUtime = object.irRequestUtime ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
